import {ApiStyleRepository} from '@infra/domain/model/Style/ApiStyleRepository';

import {GetQuizId} from './GetQuizId';
import {DeleteQuizId} from './DeleteQuizId';
import {DeleteQuizSegment} from './DeleteQuizSegment';
import {GetQuizSegment} from './GetQuizSegment';
import {GetCustomerId} from './GetCustomerId';
import {DeleteCustomerId} from './DeleteCustomerId';
import {FillBirthdate} from './FillBirthdate';

const StyleApplication = {
  getQuizId: GetQuizId.bind(undefined, ApiStyleRepository),
  deleteQuizId: DeleteQuizId.bind(undefined, ApiStyleRepository),
  getQuizSegment: GetQuizSegment.bind(undefined, ApiStyleRepository),
  deleteQuizSegment: DeleteQuizSegment.bind(undefined, ApiStyleRepository),
  getCustomerId: GetCustomerId.bind(undefined, ApiStyleRepository),
  deleteCustomerId: DeleteCustomerId.bind(undefined, ApiStyleRepository),
  fillBirthdate: FillBirthdate.bind(undefined, ApiStyleRepository),
};

export {StyleApplication};
